// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Carousel container */
.carousel-container {
    position: relative;
    width: 100%;
    margin: auto;
    overflow: hidden;
  }
  
  /* Carousel container style */
  .carousel {
    display: flex;
    align-items: center;
    position: relative;
    justify-content: center;
  }
  
  .carousel-items {
    display: flex;
    transition: transform 0.5s ease;
  }
  
  .carousel-item {
    flex-shrink: 0;
    width: 100%;
    height: 100vh; /* Adjust the height of the carousel */
    background-color: #000;
    position: relative;
    text-align: center;
  }
  
  .carousel-item img {
    width: 100vh;
    height: 100%;
    object-fit: cover;
  }
  
  .carousel-text {
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    color: #fff;
    text-align: center;
  }
  
  .carousel-text h1 {
    font-size: 2.5rem;
    margin: 0;
  }
  
  .carousel-text h6 {
    font-size: 1.5rem;
    font-weight: bold;
  }
  
  .carousel-text p {
    font-size: 1rem;
    margin-top: 10px;
  }
  
  /* Navigation buttons */
  .carousel-button {
    position: absolute;
    top: 50%;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    border: none;
    font-size: 2rem;
    padding: 10px;
    cursor: pointer;
    z-index: 10;
  }
  
  .carousel-button:hover {
    background-color: rgba(0, 0, 0, 0.8);
  }
  
  .prev {
    left: 10px;
  }
  
  .next {
    right: 10px;
  }
  
  /* Active item style */
  .carousel-item.active {
    opacity: 1;
    transition: opacity 1s ease;
  }
  
  /* Hide non-active items */
  .carousel-item:not(.active) {
    opacity: 0;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/header/Sliders/Carousel.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA,6BAA6B;EAC7B;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,+BAA+B;EACjC;;EAEA;IACE,cAAc;IACd,WAAW;IACX,aAAa,EAAE,sCAAsC;IACrD,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA,uBAAuB;EACvB;IACE,kBAAkB;IAClB,QAAQ;IACR,oCAAoC;IACpC,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,aAAa;IACb,eAAe;IACf,WAAW;EACb;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA,sBAAsB;EACtB;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA,0BAA0B;EAC1B;IACE,UAAU;EACZ","sourcesContent":["/* Carousel container */\n.carousel-container {\n    position: relative;\n    width: 100%;\n    margin: auto;\n    overflow: hidden;\n  }\n  \n  /* Carousel container style */\n  .carousel {\n    display: flex;\n    align-items: center;\n    position: relative;\n    justify-content: center;\n  }\n  \n  .carousel-items {\n    display: flex;\n    transition: transform 0.5s ease;\n  }\n  \n  .carousel-item {\n    flex-shrink: 0;\n    width: 100%;\n    height: 100vh; /* Adjust the height of the carousel */\n    background-color: #000;\n    position: relative;\n    text-align: center;\n  }\n  \n  .carousel-item img {\n    width: 100vh;\n    height: 100%;\n    object-fit: cover;\n  }\n  \n  .carousel-text {\n    position: absolute;\n    bottom: 30px;\n    left: 50%;\n    transform: translateX(-50%);\n    color: #fff;\n    text-align: center;\n  }\n  \n  .carousel-text h1 {\n    font-size: 2.5rem;\n    margin: 0;\n  }\n  \n  .carousel-text h6 {\n    font-size: 1.5rem;\n    font-weight: bold;\n  }\n  \n  .carousel-text p {\n    font-size: 1rem;\n    margin-top: 10px;\n  }\n  \n  /* Navigation buttons */\n  .carousel-button {\n    position: absolute;\n    top: 50%;\n    background-color: rgba(0, 0, 0, 0.5);\n    color: white;\n    border: none;\n    font-size: 2rem;\n    padding: 10px;\n    cursor: pointer;\n    z-index: 10;\n  }\n  \n  .carousel-button:hover {\n    background-color: rgba(0, 0, 0, 0.8);\n  }\n  \n  .prev {\n    left: 10px;\n  }\n  \n  .next {\n    right: 10px;\n  }\n  \n  /* Active item style */\n  .carousel-item.active {\n    opacity: 1;\n    transition: opacity 1s ease;\n  }\n  \n  /* Hide non-active items */\n  .carousel-item:not(.active) {\n    opacity: 0;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
